import { Box, InputLabel, Stack } from "@mui/material";
import { Textarea } from "@platform/design-system";
import { Controller, useFormContext, useWatch } from "react-hook-form";

type ScenarioNoteFieldProps = {
  label: string;
  onRef: (el: HTMLDivElement | null, id: string) => void;
  fieldName: string;
  maxLength?: number;
};

export const ScenarioNoteField: React.FC<ScenarioNoteFieldProps> = ({
  label,
  onRef,
  fieldName,
  maxLength = 4096,
}) => {
  const { control } = useFormContext();
  const value = (useWatch({ control, name: fieldName }) as string) ?? "";
  const trimmedValue = value.trim();
  const isOverLimit = trimmedValue.length > maxLength;
  const charsOverLimit = trimmedValue.length - maxLength;

  return (
    <Stack
      direction="column"
      ref={(el: HTMLDivElement | null) => {
        onRef(el, label);
      }}
    >
      <InputLabel
        htmlFor={`scenario-note-${fieldName}`}
        sx={{ fontWeight: 500 }}
      >
        {label}
      </InputLabel>
      <Box sx={{ position: "relative" }}>
        <Controller
          control={control}
          name={fieldName}
          render={({ field: { ref, ...textareaField } }) => (
            <Textarea
              {...textareaField}
              inputRef={ref}
              id={`scenario-note-${fieldName}`}
              fullWidth
              helperText={
                isOverLimit
                  ? `${charsOverLimit} character(s) over the limit`
                  : undefined
              }
              characterCounterVisible
              characterLimitMode="warn"
              maxLength={maxLength}
              sx={{
                "& .MuiInputBase-inputMultiline": { resize: "none" },
              }}
              error={isOverLimit}
            />
          )}
        />
      </Box>
    </Stack>
  );
};
